import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Routes from "./router/Routes";
import ScrollToTop from "./components/ScrollToTop";
import AOS from "aos";
import "aos/dist/aos.css";

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 1200,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>KSK Technologies | Modernized eCommerce Technologies</title>
        <meta property="og:site_name" content="KSK Technologies" />
        <meta
          property="og:url"
          content="https://ksktech.llc"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="KSK Technologies | Modernized eCommerce Technologies"
        />
        <meta
          name="keywords"
          content="software, point of sale, retail, ecommerce, saas"
        />
        <meta
          name="description"
          content="KSK Technologies is building a full suite of retail and eCommerce software."
        />
      </Helmet>
      {/* End Seo Helmet */}

      <ScrollToTop />
      <Routes />
    </>
  );
};

export default App;
